import { render, staticRenderFns } from "./productContent.vue?vue&type=template&id=5313dba0&scoped=true"
import script from "./productContent.vue?vue&type=script&lang=js"
export * from "./productContent.vue?vue&type=script&lang=js"
import style0 from "./productContent.vue?vue&type=style&index=0&id=5313dba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313dba0",
  null
  
)

export default component.exports